import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import logoUsal from '../../../images/marca-usal.png';
import logoCiencias from '../../../images/logo-usal-ciencias.png';
import logoFacultad from '../../../images/logo-facultad-enfermeria-fisioterapia.png';
import background from '../../../images/salamanca.jpg';

/**
 * Layout de la pantalla de login (tarjeta partida: panel de marca + formulario).
 * Es la única pantalla pública de la app: el alta de usuarios ya no es
 * autoservicio, la crea un administrador desde el panel de Usuarios.
 */
export default function LoginShell({ children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        py: 4,
        px: 2,
        backgroundImage: `linear-gradient(180deg, rgba(248,250,255,0.88), rgba(241,245,249,0.92)), url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 940,
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 30px 70px rgba(15, 23, 42, 0.18)',
          display: 'flex',
        }}
      >
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '42%',
            p: 5,
            position: 'relative',
            color: '#fff',
            background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 55%, #64b5f6 100%)',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              backgroundImage: `url(${background})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: 0.25,
              mixBlendMode: 'overlay',
            }}
          />
          <Box sx={{ position: 'relative' }}>
            <HealthAndSafetyOutlinedIcon sx={{ fontSize: 34, opacity: 0.95 }} />
            <Typography variant="overline" sx={{ display: 'block', mt: 3, opacity: 0.85, letterSpacing: 1.2 }}>
              Sistema de seguimiento clínico
            </Typography>
            <Typography variant="h4" sx={{ mt: 1, fontWeight: 700, lineHeight: 1.25 }}>
              Bienvenido/a de nuevo
            </Typography>
            <Typography sx={{ mt: 2, opacity: 0.92, maxWidth: 320 }}>
              Accede para gestionar pacientes, valoraciones y programas terapéuticos.
            </Typography>
          </Box>
          <Typography variant="caption" sx={{ position: 'relative', opacity: 0.75 }}>
            Facultad de Enfermería y Fisioterapia
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            backgroundColor: '#fff',
            p: { xs: 4, sm: 6 },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: '100%' }}>{children}</Box>
        </Box>
      </Paper>

      <Stack
        direction="row"
        spacing={4}
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        sx={{ backgroundColor: 'rgba(255,255,255,0.88)', borderRadius: 3, px: 3, py: 1.5 }}
      >
        <img src={logoCiencias} alt="Facultad de Ciencias" style={{ height: 40 }} />
        <img src={logoUsal} alt="Universidad de Salamanca" style={{ height: 40 }} />
        <img src={logoFacultad} alt="Facultad de Enfermería y Fisioterapia" style={{ height: 40 }} />
      </Stack>
    </Box>
  );
}
